<template>
    <v-password-field v-model="passwordConfirm" v-bind="{ ...$attrs, rules }" @input="emit" ref="input" />
</template>
<script>
import VPasswordField from "./v-password-field.vue";
export default {
    components: {
        VPasswordField,
    },
    props: {
        value: { type: Boolean, default: undefined },
        password: { type: String, default: null },
    },
    data: () => ({
        passwordConfirm: null,
    }),
    computed: {
        isConfirmed() {
            return this.passwordConfirm && this.passwordConfirm == this.password;
        },
        rules() {
            return [() => this.isConfirmed || "비밀번호가 일치하지 않습니다"];
        },
    },
    watch: {
        password() {
            this.$refs["input"].validate();
        },
        isConfirmed() {
            this.emit();
        },
    },
    methods: {
        emit() {
            this.$emit("input", this.isConfirmed);
        },
    },
};
</script>
